import React from "react";

export default function NotFoundPage() {
  return (
    <div className="relative flex flex-col items-center justify-center w-screen h-screen bg-white overflow-hidden">
      
      {/* Background GIF (Behind the content) */}
      <div className="absolute">
        <img
          src="https://media.giphy.com/media/14uQ3cOFteDaU/giphy.gif" 
          alt="404 Not Found"
          className="w-full h-full object-cover" 
        />
      </div>

      {/* Overlay for better text readability (Optional) */}
      <div className="absolute inset-0 bg-white bg-opacity-70 z-10" />

      {/* Content Container */}
      <div className="relative z-20 text-center text-black p-4">
        <h1 className="text-4xl sm:text-6xl md:text-8xl font-extrabold tracking-widest mb-4 drop-shadow-lg">
          404
        </h1>
        <p className="text-lg md:text-xl mt-4 font-semibold">Page Not Found</p>
        <p className="text-base md:text-lg mt-2 font-light max-w-md mx-auto">
          Oops! The page you are <br /> looking for doesn’t exist.
        </p>

        {/* Home Button (replace with your routing as needed) */}
        <button
          
          className="mt-8 px-8 py-3 rounded-md bg-black text-white font-semibold hover:bg-gray-800 transition-shadow drop-shadow-lg hover:drop-shadow-2xl"
        >
          Go Home
        </button>
      </div>
    </div>
  );
}
